import { render, staticRenderFns } from "./BadgeDoCliente.vue?vue&type=template&id=e53770b6&scoped=true&"
import script from "./BadgeDoCliente.vue?vue&type=script&lang=ts&"
export * from "./BadgeDoCliente.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeDoCliente.vue?vue&type=style&index=0&id=e53770b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53770b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
